import React, { useEffect } from "react";

import {
  createProviderLinkOnClose,
  createProviderLinkOnFailure,
  createProviderLinkOnInit,
  createProviderLinkOnSuccess,
} from "../../helpers/webViewCallback";
import { callBackendAPI } from "../../helpers/api";

function TellerProvider(props) {
  const { providerData } = props || {};

  useEffect(() => {
    window.analytics.track("provider_link_teller_page_view", {
      providerData,
    });
  }, []);

  const initTeller = () => {
    var tellerConnect = window.TellerConnect.setup({
      applicationId: process.env.REACT_APP_TELLER_APP_ID,
      institution: providerData.institution_id,
      onInit: function () {
        console.log("Teller Connect has initialized");
        window.analytics.track("provider_link_teller_provider_init", {
          target: "providerLink",
          institution: providerData.institution_id,
          providerData,
        });
      },
      onSuccess: async function (enrollment) {
        console.log("User enrolled successfully", enrollment.accessToken);
        const createItemRes = await callBackendAPI({
          path: `/provider_link/create_link`,
          method: "POST",
          body: {
            link_type: providerData.wallet_type,
            provider_id: providerData.id,
            public_token: "",
            subtype: "",
            address: "",
            access_token: enrollment.accessToken,
          },
        });
        console.log({ createItemRes });
        if (createItemRes && createItemRes.user_wallet_id) {
          createProviderLinkOnSuccess({
            message: "Account connected successfully",
            walletId: createItemRes.user_wallet_id,
          });
          window.analytics.track("provider_link_success", {
            source: "teller_provider_account_connect",
            target: "providerLink",
            walletId: createItemRes.user_wallet_id,
            providerData,
          });
        }
      },
      onFailure: function (failure) {
        console.log(failure);
        createProviderLinkOnFailure("Something went wrong please try again");
        window.analytics.track("provider_link_failure", {
          source: "teller_provider_account_connect",
          target: "providerLink",
          message: "Something went wrong please try again",
          failure,
          providerData,
        });
      },
      onExit: function () {
        createProviderLinkOnClose();
        window.analytics.track("provider_link_exit", {
          source: "teller_provider_account_connect",
          target: "providerLink",
          providerData,
        });
      },
    });
    tellerConnect.open();
  };

  useEffect(() => {
    initTeller(providerData.institution_id);
  }, [providerData]);

  return <div></div>;
}

export default TellerProvider;
